import { createApp } from 'vue'
import { ref } from 'vue'
import App from './App.vue'
import './style.css'
import './i18n'

const app = createApp(App)
app.mount('#app')
